import { PreislistenKatalogFormData } from "./preislistenKatalogFormData";

export class UpdatePreislistenKatalogRequest {
  id: string;
  name: string;

  constructor(id: string, name: string) {
    this.id = id;
    this.name = name;
  }
}
